<template>
    <div>
        <!-- 图片 -->
        <div class="bg">

            <div class="sub-title">About</div>
            <div class="title">关于我们</div>
        </div>
        <div class="m-3">
            <div class="border">
                <img src="@/assets/img/about.jpg" style="width: 100%;" alt="">
                <div class="content">
                    <p>凡己科技（苏州）有限公司是一家致力于中低压、大电流类交流电机控制器、智能终端和远程管理系统等产品的研发与销售的国家级高新技术企业。是中国工业车辆行业协会理事单位，江苏省专精特新中小企业，中国首个非道路电动控制器标准的主要起草单位。
                    </p>
                    <p>公司自2011年成立至今，始终专注于电控部件的研发，坚持以自主核心技术为客户服务，拥有7项发明专利（在申请8个发明），30余个实用新型专利，6个外观专利，9个软件著作权。公司自主研发生产的交流电机控制器、智能仪表、远程监控管理系统等系列产品，成功应用于电动叉车、电动仓储车、电动观光车、高尔夫球车、环卫车、高空作业平台、工程机械、农业、园林、船舶等领域。客户覆盖林德叉车、安徽合力、杭叉集团等整车行业龙头企业，年产能60万台，为非道路领域整机企业提供电动控制、智能、网联整体解决方案。
                    </p>
                    <p>2015年，凡己科技自主研发生产的V系列交流控制器获汽车行业双项创新奖。2019年，D系列交流控制器再行行业创新金奖。2021年，公司创建十周年之际，第三代控制器技术面世，双MCU架构、电子式接触器、新一代功率器件、兼容永磁与交流电机等国际领先技术为行业开创先河，赋能非道路领域的电动化、智能化和网联化转型升级。
                    </p>
                </div>
            </div>
            <div class="border">
                <div>
                    <div class="title">客户价值</div>
                    <div class="mt-1">Customer Value</div>
                </div>
                <div>
                    <div class="flex-row mt-1">
                        <div style="font-weight: 700;">敏捷：</div>
                        <div style="margin-left: 10px;">对客户的应用需求做出快速响应</div>
                    </div>
                    <div class="flex-row mt-1">
                        <div style="font-weight: 700;">精湛：</div>
                        <div style="margin-left: 10px;">安全可靠的产品、高效率的工艺质控</div>
                    </div>
                    <div class="flex-row mt-1">
                        <div style="font-weight: 700;">专业：</div>
                        <div style="margin-left: 10px;">国际领先的核心技术和先进测试能力</div>
                    </div>
                    
                </div>
            </div>
            <div class="border">
                <div>
                    <div class="title">企业愿景</div>
                    <div class="mt-1">Vision</div>
                </div>
                <div class="mt-1">
                    <p style="line-height: 30px;">做非道路电驱动的世界级企业，为推动全球电动化的普及做出贡献。</p>
                </div>
            </div>
            <div class="border">
                <div>
                    <div class="title">共同价值观</div>
                    <div class="mt-1">Shared Value</div>
                </div>
                <div class="mt-1">
                    <p>客户-客户第一，服务至上；</p>
                    <p>责任-勇于担当，拥抱变化；</p>
                    <p>诚信-言而有信，兑现承诺；</p>
                    <p>简单-坦诚沟通，高效行动。</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script >
export default {
    data() {
        return {
           
        }
    },
    methods: {
        
    },
    mounted() {
        debugger
        let vType= this.$route.query.type;
        if(vType!=null&&vType=="app"){
          this.$emit("hideHead");
        }
    }
}
</script>

<style scoped>
.bg {
    background: url('../../assets/img/aboutusbanner.jpg') no-repeat;
    background-size: 100% ;
    height: 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.m-3 {
    margin: 30px;
}

.video {
    background-color: #00585252;
    height: 200px;
    width: 100%;
}

.sub-title {
    display: inline-block;
    background-color: #0AA00A;
    color: #fff;
    border-radius: 5px;
    border-top-right-radius: 0;
    font-size: 12px;
    padding: 2px 5px;
}

.title {
    font-size: 20px;
    font-weight: 700;
    margin-top: 5px;
}

.mt-1 {
    margin-top: 10px;
    line-height: 30px;
}

.mt-3 {
    margin-top: 30px;
}

.content {
    margin-top: 10px;
    text-indent: 2rem;
}
.content p{
  margin-top: 10px;
  text-indent: 2rem;
  line-height: 30px;
}

.product-item {
    width: 48%;
    margin-bottom: 10px;
    border: 1px solid #eee
}

.border {
    border-bottom: 1px solid #eee;
    padding: 30px 0;
}

.product-img {
    /* background-color: #eee; */
    width: 100%;
    height: 100px;
}

.customer-item {
    height: 100px;
    margin-bottom: 10px;
}

.customer-left {
    border-bottom: 1px dashed #0AA00A;
    width: 65%;
}

.customer-right {
    width: 30%;
    background-color: #0AA00A;
    color: #fff;
}

.project-item {
    width: 50%;
    margin-bottom: 30px;
}

.input {
    border-radius: 10px;
    padding: 5px;
    width: 100px;
}
</style>


// WEBPACK FOOTER //
// src/views/about/m_index.vue